import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Button from "../../../Components/Button/Button";
import CardHeader from "../../../Components/Card/CardHeader";
import Input from "../../../Components/Input/Input";
import Select from "../../../Components/Select/Select";
import { HttpContext } from "../../../HttpContext";

import styles from "./object.edit.module.css";

export default function ObjectEdit() {
  const [object, setObject] = useState();
  const { httpClient } = useContext(HttpContext);
  const { id } = useParams();

  useEffect(() => {
    getObject()
  }, [])

  async function getObject() {
    const response = await httpClient.get(`/object/${id}`);
    setObject(response.data)
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <CardHeader title="Редактирование/Создание объекта" />
        <div className={styles.card_body}>
          <Input label="Кадастровый номер" placeholder="Введите номер для поиска" />
          <Select label="Вид объекта" >
            <option>Квартира</option>
            <option>Жилой дом</option>
            <option>Нежилое помещение</option>
            <option>Машиноместо</option>
            <option>Иной</option>
            <option>Здание</option>
            <option>Помещение</option>
            <option>Объект незавершённого строительства</option>
            <option>Земельный участок</option>
            <option>Сооружение</option>
            <option>Нежилое здание</option>
            <option>Жилой дом</option>
          </Select>
          <Input label="Адрес по ФИАС"/>
          <Input label="Полный адрес (если не нашелся адрес по ФИАС)"/>
          <div className={styles.separated}>
            <Input label="Площадь обьекта"/>
            <Input label="Единицы измерения"/>
          </div>
          <Input label="Описание" subLabel="Название ЖК, описание объекта"/>
          <Button text="Сохранить"/>
        </div>
      </div>
    </div>
  )
}